import React, { useState, useEffect, useRef } from "react";
import { Redirect, Route, Link, useHistory } from "react-router-dom";
import api from "services/api";
import { Accordion } from "react-bootstrap";
import Translator, { __ } from "services/Translator";

function Subscrib(props) {
  const history = useHistory();

  return (
    <>
      <div className="access_control_area faq-container">
        {/* <img
          alt=""
          className="faq-bg"
          src={require("assets/winnabull/images/common/glow-light-min.png")}
        /> */}
        {props.heading && (
          <h3 className="faq-main-heading">
            {__("Join the Winnabull Newsletter for Exclusive Perks!")}
          </h3>
        )}

        <div className="subscrib-area">
          <div className="heading">Ready to Play More—For Free?</div>
          <div className="sub-heading">
            As a subscriber, you'll unlock extra perks and tips to maximize your
            gameplay. Don't miss out—sign up today and start reaping the
            rewards.
          </div>

          <div className="subscrib-input-area">
            <input type="text" placeholder="Enter your email address" />
            <a className="commonBtn greenBtn">Sign Up</a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Subscrib;
